module.exports = __webpack_public_path__ + "static/media/growth.f9c2fc59.webp";